import { Component, Fragment, h, Method, Prop } from '@stencil/core';
import { store } from '@stencil/redux';
import { Unsubscribe } from 'redux';
import { reInit, addError } from '../../redux/actions';
import { RootState } from '../../redux/reducers';
import { Cart, Translations } from '../../redux/types';
import { CartIcon } from '../../types/types';

@Component({
  tag: 'rtr-checkout-controller',
  shadow: true,
})
export class RtrCheckoutController {
  @Prop({ mutable: true }) showCheckout: boolean = false;
  @Prop({ mutable: true }) showReservation: boolean = false;
  @Prop({ mutable: true }) showCart: boolean = false;
  @Prop({ mutable: true }) showProcessingSpinner: boolean = false;
  @Prop({ mutable: true }) showFilters: boolean = false;
  @Prop({ mutable: true }) accessToken: string = null;
  @Prop({ mutable: true }) translations: Translations;
  @Prop({ mutable: true }) locale: string;

  @Prop() customCartIcon: CartIcon = null; // for preview

  unsubscribe!: Unsubscribe;
  reInit!: typeof reInit;
  addError!: typeof addError;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        showCheckout: state.app.showCheckout,
        showReservation: !!state.app.showReservationForId && this.isThisItemInCart(state.app.showReservationForId, state.bookingDetails.cart),
        showCart: !state.app.showCheckout && !state.app.showDetailsForId && !state.app.showReservationForId,
        showProcessingSpinner: state.app.showProcessingSpinner,
        showFilters: state.search.showFilters,
        accessToken: state.app.accessToken,
        translations: state.system.translations,
        locale: state.app.locale,
      };
    });

    store.mapDispatchToProps(this, {
      reInit,
      addError,
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  isThisItemInCart = (itemId: string, cart: Cart): boolean => {
    return cart?.items.some(item => item.itemId === itemId);
  };

  @Method()
  async updateAccount(accessToken: string, onSuccess = () => null) {
    const currentAccessToken = this.accessToken;

    // do nothing if account did not change
    if (accessToken === currentAccessToken) {
      onSuccess();
      return;
    }

    (window as any).RTR_ACCESS_TOKEN = accessToken;

    this.reInit(accessToken, onSuccess);
  }

  render() {
    return (
      <rtr-ready-wrapper
        renderOnReady={() => {
          return (
            <Fragment>
              <rtr-article-details />

              {this.showReservation && <rtr-cart-reservation />}

              {this.showCheckout && <rentware-checkout-modal />}

              {this.showCart && <rentware-cart-expandable customCartIcon={this.customCartIcon} />}

              {this.showProcessingSpinner && <rentware-checkout-spinner />}

              <rentware-search-filters />
              <rtr-errors />
            </Fragment>
          );
        }}
      />
    );
  }
}
